import {
  isValidEmail,
  isNameWithSpaces,
  isValidPhoneNumber,
  isValidNANPPhoneNumber,
  normalizePhoneNumberRedesign,
  isNotSamePhoneNumber,
} from './validation';

/**
 * NSADT- 118384
 * If any one of prefered Names is available, we need to show the prefered Name
 * If both prefered Names are empty, then display legal name
 * @param [object] - contactInfo
 * @param [string] - defaultValue / firstName
 * @returns preferFirstName/firstName
 */

export const getFirstName = (contactInfo, defaultValue = '', isAALContactInfoUpdated = false) => {
  if (isAALContactInfoUpdated) {
    return defaultValue || '';
  }
  if (contactInfo?.preferFirstName || contactInfo?.preferLastName) {
    return contactInfo?.preferFirstName || '';
  }
  return defaultValue || '';
};

/**
 * @param [object] - contactInfo
 * @param [string] - defaultValue (lastName)
 * @returns preferLastName/lastName
 */
export const getLastName = (contactInfo, defaultValue = '', isAALContactInfoUpdated = false) => {
  if (isAALContactInfoUpdated) {
    return defaultValue || '';
  }
  if (contactInfo?.preferFirstName || contactInfo?.preferLastName) {
    return contactInfo?.preferLastName || '';
  }
  return defaultValue || '';
};

export const getContactNumber = (contactInfo) => {
  if (contactInfo?.contactPhoneNumber) {
    return contactInfo?.contactPhoneNumber;
  }
  if (contactInfo?.contactPersonPhone) {
    return contactInfo?.contactPersonPhone;
  }
  if (contactInfo?.address?.phoneNumber) {
    return contactInfo.address.phoneNumber;
  }
  return '';
};

export const getFullAddress = (billingAddress) => {
  if (!billingAddress) return '';

  const { addressLine1, addressLine2, city, state, zipCode } = billingAddress;
  if (addressLine1 || addressLine2 || city || state || zipCode) {
    const address = [];
    if (addressLine1) address.push(addressLine1);
    if (addressLine2) address.push(addressLine2);
    if (city) address.push(city);
    if (state) address.push(state);
    if (zipCode) address.push(zipCode);

    const fullAddress = address.length ? address.join(', ') : '';
    return fullAddress;
  }

  return '';
};

export const getShippingAddress = (addressInfo) => {
  if (!addressInfo) {
    return { addressLine1: '', addressLine2: '', city: '', state: '', zipCode: '', fipsCode: '', fullAddress: '' };
  }

  const lqAddress = {
    addressLine1: addressInfo.addressLine1 || '',
    addressLine2: addressInfo.addressLine2 || '',
    city: addressInfo.city || '',
    state: addressInfo.state || '',
    zipCode: addressInfo.zipCode || '',
    fipsCode: addressInfo.fipsCode || '',
    fullAddress: '',
  };

  lqAddress.fullAddress = getFullAddress(lqAddress);
  return lqAddress;
};

export const parseNumber = (number) => {
  let parsedNumber = null;
  if (number) {
    parsedNumber = `${number.slice(0, 3)}.${number.slice(3, 6)}.${number.slice(6, 10)}`;
    return parsedNumber;
  }
  return parsedNumber;
};

export const unParseNumber = (number) => {
  let unParsedNumber = null;
  if (number) {
    unParsedNumber = number.replace(/\./g, '');
  }
  return unParsedNumber;
};

const ConstantsStrings = {
  emptyFirstNameErrorText: 'You must enter a First name.',
  validFirstNameErrorText: 'Please enter a valid first name.',
  emptyLastNameErrorText: 'You must enter a Last name.',
  validLastNameErrorText: 'Please enter a valid Last name.',
  maxEmailErrorText: "You've changed your email address too many times. Please try again later.",
  validEmailErrorText: 'Please enter a valid email address.',
  validPhoneNumberErrorText: 'Please enter a valid phone number.',
};

export const handleFieldValidation = (fieldName, data, emailMaxAttempts) => {
  const fieldValue = data?.trim();
  switch (fieldName) {
    case 'fName':
    case 'lName':
      let showFirstNameError = false;
      let firstNameErrorMessage = '';
      if (fieldValue?.length === 0) {
        showFirstNameError = true;
        firstNameErrorMessage = fieldName === 'fName' ? ConstantsStrings?.emptyFirstNameErrorText : ConstantsStrings?.emptyLastNameErrorText;
      } else if (!isNameWithSpaces(fieldValue)) {
        showFirstNameError = true;
        firstNameErrorMessage = fieldName === 'fName' ? ConstantsStrings?.validFirstNameErrorText : ConstantsStrings?.validLastNameErrorText;
      } else {
        showFirstNameError = false;
        firstNameErrorMessage = false;
      }

      return {
        value: fieldValue,
        showError: showFirstNameError,
        errorMessage: firstNameErrorMessage,
      };
    case 'email':
      let emailErrorText = '';
      let showEmailError = false;
      if (!isValidEmail(fieldValue)) {
        emailErrorText = emailMaxAttempts ? ConstantsStrings?.maxEmailErrorText : ConstantsStrings?.validEmailErrorText;
        showEmailError = true;
      } else {
        emailErrorText = false;
        showEmailError = false;
      }
      return {
        value: fieldValue,
        showError: showEmailError,
        errorMessage: emailErrorText,
        manualValidation: showEmailError,
      };

    case 'phoneNumber':
      const phoneNumberValue = fieldValue?.replace(/([^\w ]|_)/g, '');
      let phoneErrorText = false;
      let showPhoneNumberError = false;
      const parsedphoneNumber = unParseNumber(phoneNumberValue);
      //  inside not validPhoneNumber, HOW validphoneNumber case camse
      if (!isValidPhoneNumber(parsedphoneNumber)) {
        if (phoneNumberValue && parsedphoneNumber?.length !== 10) {
          phoneErrorText = ConstantsStrings?.validPhoneNumberErrorText;
          showPhoneNumberError = true;
        } else if (parsedphoneNumber === '0000000000' || parsedphoneNumber === '9999999999') {
          phoneErrorText = ConstantsStrings?.validPhoneNumberErrorText;
          showPhoneNumberError = true;
        } else if (isNotSamePhoneNumber(parsedphoneNumber)) {
          phoneErrorText = ConstantsStrings?.validPhoneNumberErrorText;
          showPhoneNumberError = true;
        } else if (isValidPhoneNumber(normalizePhoneNumberRedesign(fieldValue))) {
          //  need to check whether it is a right condition
          //   this.props.contactPhoneCTA({ contactFormError: 'noError' });
        }
      } else if (parsedphoneNumber === '0000000000' || parsedphoneNumber === '9999999999') {
        phoneErrorText = ConstantsStrings?.validPhoneNumberErrorText;
        showPhoneNumberError = true;
      } else if (!isValidNANPPhoneNumber(parsedphoneNumber)) {
        phoneErrorText = ConstantsStrings?.validPhoneNumberErrorText;
        showPhoneNumberError = true;
      } else if (isNotSamePhoneNumber(parsedphoneNumber)) {
        phoneErrorText = ConstantsStrings?.validPhoneNumberErrorText;
        showPhoneNumberError = true;
      } else {
        phoneErrorText = false;
        showPhoneNumberError = false;
      }
      return {
        value: phoneNumberValue,
        showError: showPhoneNumberError,
        errorMessage: phoneErrorText,
      };
    default:
      return '';
  }
};

export const handleAALFieldValidation = (fieldName, fieldValue) => {
  const showError = false;
  const errorMessage = false;

  if (fieldName?.length === 0) {
    if (fieldName === 'fName') {
      return {
        value: fieldValue,
        showError: true,
        errorMessage: ConstantsStrings?.validFirstNameErrorText,
      };
    }
    if (fieldName === 'lName') {
      return {
        value: fieldValue,
        showError: true,
        errorMessage: ConstantsStrings?.validLastNameErrorText,
      };
    }

    if (fieldName === 'email') {
      return {
        value: fieldValue,
        showError: true,
        errorMessage: ConstantsStrings?.validEmailErrorText,
      };
    }
    if (fieldName === 'phoneNumber') {
      return {
        value: fieldValue,
        showError: true,
        errorMessage: ConstantsStrings?.validPhoneNumberErrorText,
      };
    }
  } else if ((fieldName === 'fName' || fieldName === 'lName') && !isNameWithSpaces(fieldValue)) {
    return {
      value: fieldValue,
      showError: true,
      errorMessage: fieldName === 'fName' ? ConstantsStrings?.validFirstNameErrorText : ConstantsStrings?.validLastNameErrorText,
    };
  }
  return { value: fieldValue, showError, errorMessage };
};
